<template>
    <div clas="pl-2">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn small text icon v-bind="attrs" v-on="on" class="gridbutton">
                    <v-icon medium color="blue">mdi-information-variant</v-icon>
                </v-btn>                
            </template>
            <span>
                <div>
                    Mail will be sent to: 
                </div>
                <div v-if="hocts.length !== 0">
                    <tr v-for="(contact, index) in hocts" :key="index">
                        <td class="pr-3">{{ contact.role }}</td>
                        <td class="pr-3">{{ contact.name }}</td>
                        <td class="pr-3">{{ contact.email }}</td>                    
                        <td>{{ contact.taalcode }}</td> 
                    </tr>
                </div>
                <div v-else>
                    (no recipients)
                </div>
            </span>
        </v-tooltip> 
    </div> 
</template>

<script>
    export default {     
        props: {
            heho_encrid: {
                type: String,
                default: ''
            },      
        },             
        data() {
            return {
                hocts: [],
            }
        },
        mounted() {
            this.getHoctRecords();
        },
        methods: {  
            getHoctRecords() {
                this.$axios.post("ares/json/ares/heho/getHehoHoct.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHehoHoct"
                    },
                    getHehoHoct: {
                        heho_encrid: this.heho_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error.message);
                    } else {
                        this.hocts = res.data.getHehoHoct;
                    }
                })
            },        
        }
    }
</script>
